import React from 'react';
import { Button } from './Button';
import { MapPinOff, ArrowLeft, Home } from 'lucide-react';
import { navigate } from './Router';

export const NotFound: React.FC = () => {
  return (
    <div className="min-h-screen bg-white flex flex-col items-center justify-center p-4 relative overflow-hidden">
      {/* Background Decor */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-brand-orange/5 rounded-full blur-3xl -z-10 translate-x-1/2 -translate-y-1/2"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-brand-dark/5 rounded-full blur-3xl -z-10 -translate-x-1/2 translate-y-1/2"></div>

      <div className="text-center max-w-2xl mx-auto relative z-10 animate-fade-in-up">
        {/* Icon / Graphic */}
        <div className="relative inline-block mb-8">
          <div className="w-32 h-32 bg-brand-gray rounded-3xl flex items-center justify-center transform rotate-6 shadow-xl border border-gray-100">
            <MapPinOff className="w-16 h-16 text-brand-orange" strokeWidth={1.5} />
          </div>
          <div className="absolute -top-4 -right-4 bg-brand-dark text-white font-black text-xl px-4 py-2 rounded-lg transform -rotate-6 shadow-lg">
            404
          </div>
        </div>

        {/* Text Content */}
        <h1 className="text-4xl md:text-6xl font-black text-brand-dark mb-6 tracking-tight">
          Falsch abgebogen.
        </h1>
        
        <p className="text-lg md:text-xl text-gray-600 mb-10 leading-relaxed font-medium">
          Wie in der ersten Fahrstunde: <br className="hidden md:block" />
          Hier geht es leider nicht weiter. Die gesuchte Seite hat die Prüfung nicht bestanden.
        </p>

        {/* Actions */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Button 
            onClick={() => navigate('/')} 
            variant="primary" 
            className="flex items-center justify-center gap-2 shadow-xl shadow-orange-200/50"
          >
            <Home size={18} />
            Zur Startseite
          </Button>
          
          <Button 
            onClick={() => window.history.back()} 
            variant="outline"
            className="flex items-center justify-center gap-2"
          >
            <ArrowLeft size={18} />
            Zurück
          </Button>
        </div>
      </div>

      {/* Footer Hint */}
      <div className="absolute bottom-8 text-gray-400 text-sm font-medium">
        zackig<span className="text-brand-orange">.</span>marketing
      </div>
    </div>
  );
};